<div padding>
    <mat-spinner mode="indeterminate" [diameter]="diameter"></mat-spinner>

    <p *ngIf="message">{{message}}</p>
</div>